namespace Umbrella.CustomerService.CustomerCard.Contracts {
    import IContractResource = Modules.Housing.IContractResource;
    import ContractFilterModel = Modules.Housing.ContractFilterModel;
    import debounce = Umbrella.Helpers.debounce;

    export interface CustomerContractFiltersComponentState {
        person: PersonModel;
    }

    @Component('CustomerService', {
        selector: 'customer-contract-filters',
        templateUrl:
            '/CustomerService/_CustomerCard/_Contracts/CustomerContractFiltersComponent/CustomerContractFilters.html',
        bindings: {
            state: '<'
        }
    })
    @Inject('ContractResource', 'CustomerCardContractInfoService')
    class CustomerContractFiltersComponent {
        public state: CustomerContractFiltersComponentState;
        public displayedContracts: ContractFilterModel[] = [];
        public selectedContract: ContractFilterModel;

        constructor(
            private contractResource: IContractResource,
            private contractInfoService: CustomerCardContractInfoService
        ) {}

        public $onChanges() {
            const customerId = this.getCustomerId();
            const contractsLoaded = this.displayedContracts.length > 0;
            if (customerId && !contractsLoaded) this.loadContracts(customerId);
        }

        public searchContract = debounce(
            (query: string) => {
                const customerId = this.getCustomerId();
                this.loadContracts(customerId, query);
            },
            500,
            false
        );

        public filterByContract(contract: ContractFilterModel) {
            this.contractInfoService.filterByContract(contract && contract.id);
        }

        private getCustomerId(): System.Guid {
            return (
                this.state &&
                this.state.person &&
                this.state.person.roles['customer']
            );
        }

        private loadContracts(customerId: System.Guid, query?: string): void {
            this.contractResource
                .getFilterValuesByRoleId({
                    id: customerId,
                    page: 0,
                    pageSize: 255,
                    searchQuery: query
                })
                .$promise.then(data => {
                    this.displayedContracts = data.items;
                });
        }
    }
}
